<p-blockUI [blocked]="blockedDocument">
 <div class="fixed inset-0 flex flex-col items-center justify-center bg-gray-900/50 z-50">
        <p-progressSpinner></p-progressSpinner>
        <span class="text-white text-lg mt-4">{{loadingMessage}}</span>
 </div>
</p-blockUI>
<p-panel header="New Election">
   <p-toast />
   <form class="mx-auto p-6 ">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Name -->
            <div class="w-full md:w-[30rem]">
                <app-input-text [form]="electionForm" field="name" label="Election Name" placeholder="Election Name"></app-input-text>

                <app-input-textarea [form]="electionForm" field="description" label="Description" placeholder="Description" [maxlength]="250"></app-input-textarea>
            </div>

            <!-- Status -->
            <div class="w-full md:w-[30rem]">
                <app-input-select [form]="electionForm" field="active" label="Active" placeholder="" [options]="statusList"></app-input-select>
            </div>

            <!-- Type -->
             <div class="w-full">
                <div class="md:w-[30rem]">
                    <app-input-select [form]="electionForm" field="type" label="Type" placeholder="Election Type" [options]="typeList"></app-input-select>

                    @if(electionForm.controls.type.value === "OTHER") {
                       <app-input-text [form]="electionForm" field="otherType" label="Please specify election type" placeholder="Type"></app-input-text>
                    }
                </div>

                <div class="w-full md:w-[30rem]">
                    <app-input-select [form]="electionForm" field="processMethod" label="Process Method" placeholder="Process Method" [options]="processMethodList"></app-input-select>
                </div>

                <div class="md:w-[30rem]">
                    <app-date-input [form]="electionForm" field="startDate"  label="Ballot Mail Date" placeholder=""></app-date-input>
                    <app-date-input [form]="electionForm" field="endDate" label="Election Date" placeholder=""></app-date-input>
                </div>
                <div class="w-full md:w-[30rem]">
                    <app-input-number [form]="electionForm" field="voteGoal" label="Vote Goal" placeholder="Vote Goal"></app-input-number>

               </div>
             </div>

    </div>



    </form>
            <!-- Submit Button -->
            <div class="text-right mr-8">
                <p-button
                type="submit"
                label="Cancel" severity="secondary"
                class="mr-3"
                routerLink="/election"
                ></p-button>
                <p-button
                type="submit"
                label="Save Election"
                (onClick)="save()"
                ></p-button>
            </div>

</p-panel>
